import { getStockDetails } from "../firebase/functions"; // adjust path as needed

// Define options with flag keys (we import only the SVGs we need)
const countryOptions = [
  { code: "UK", label: "UK", flag: "gb" },
  { code: "EU", label: "EU", flag: "eu" },
  { code: "US", label: "US", flag: "us" },
  { code: "CA", label: "CA", flag: "ca" },
  { code: "AU", label: "AU", flag: "au" },
  { code: "NZ", label: "NZ", flag: "nz" },
];

// Map regions and currency codes
const regionMap = {
  US: "US-CA",
  CA: "US-CA",
  AU: "OC",
  NZ: "OC",
};
const currencyMap = {
  GB: "GBP",
  EU: "EUR",
  US: "USD",
  CA: "CAD",
  AU: "AUD",
  NZ: "NZD",
};

const currencySymbolMap = {
  GBP: "£",
  EUR: "€",
  USD: "$",
  CAD: "$",
  AUD: "$",
  NZD: "$",
};

const getInitialCountryData = () => {
  const stored = localStorage.getItem("selectedCountryData");
  if (stored) {
    try {
      const parsed = JSON.parse(stored);
      if (
        parsed.selectedCountry &&
        countryOptions.some((c) => c.code === parsed.selectedCountry)
      ) {
        return parsed;
      }
    } catch (e) {
      // ignore parse error
    }
  }
  // Default values
  const selectedCountry = "UK";
  const region = regionMap[selectedCountry] || selectedCountry;
  const currency = currencyMap[selectedCountry] || "GBP";
  return { selectedCountry, region, currency };
};

function getSelectedCountry() {
  try {
    const stored = localStorage.getItem("selectedCountryData");
    if (stored) {
      const parsed = JSON.parse(stored);
      return parsed.currency || "GBP";
    }
  } catch (e) {}
  return "GBP";
}

// Helper to get price and symbol for selected country
function getPriceForCountry(prices, countryCode) {
  if (!Array.isArray(prices)) return { price: null, symbol: "" };
  const priceObj = prices.find((p) => p.currency === countryCode);
  return priceObj
    ? { price: priceObj.price, symbol: priceObj.symbol || "" }
    : { price: null, symbol: "" };
}

function getSelectedRegion() {
  try {
    const stored = localStorage.getItem("selectedCountryData");
    if (stored) {
      const parsed = JSON.parse(stored);
      return parsed.region || "GB";
    }
  } catch (e) {}
  return "GB";
}

const getRegion = (code) => regionMap[code] || code;
const getCurrency = (countryCode) => currencyMap[countryCode] || "GBP";
const getCurrencySymbol = (countryCode) =>
  currencySymbolMap[countryCode] || "£";

// Calculate total price based on selected currency
function getBasketTotalPrice(basket, products) {
  return basket.reduce((sum, item) => {
    const product = products.find((p) => p.id === item.id);
    if (product && product.prices) {
      const { price } = getPriceForCountry(
        product.prices,
        getSelectedCountry()
      );
      return price ? sum + Number(price) * (item.quantity || 1) : sum;
    }
    return sum;
  }, 0);
}

async function checkBasketStockOnRegionChange(region) {
  const basket = JSON.parse(localStorage.getItem("basket")) || [];
  if (!basket.length) return [];

  const productsToCheck = basket.map((item) => ({
    id: item.productid,
    region: region,
  }));

  const stockRes = await getStockDetails(productsToCheck);

  let outOfStockVariantIds = [];
  if (stockRes?.results) {
    const outOfStockItems = stockRes.results.filter(
      (result) => result.status !== "in-stock"
    );
    if (outOfStockItems.length > 0) {
      outOfStockVariantIds = outOfStockItems
        .map((outItem) => {
          const basketItem = basket.find((item) => item.id === outItem.id);
          return basketItem?.variantId;
        })
        .filter(Boolean); // Remove undefined/null
    }
  }
  return outOfStockVariantIds;
}

export {
  getInitialCountryData,
  getSelectedCountry,
  getPriceForCountry,
  getSelectedRegion,
  getRegion,
  getCurrency,
  getBasketTotalPrice,
  countryOptions,
  regionMap,
  currencyMap,
  currencySymbolMap,
  getCurrencySymbol,
  checkBasketStockOnRegionChange,
};
